module.exports = __webpack_public_path__ + "static/media/facerecog.9306d90b.png";